import {
  AWS_REGION,
  COGNITO_USERPOOL_ID,
  COGNITO_CLIENT_ID,
  COGNITO_APP_DOMAIN,
  COGNITO_REDIRECT_SIGN_IN,
  COGNITO_REDIRECT_SIGN_OUT
} from '@/constants/aws';

const amplifyConfiguration = {
  // aws_project_region: AWS_REGION,
  oauth: {
    domain: COGNITO_APP_DOMAIN,
    scope: [
      'openid',
      'email'
      // 'aws.cognito.signin.user.admin'
    ],
    redirectSignIn: COGNITO_REDIRECT_SIGN_IN,
    redirectSignOut: COGNITO_REDIRECT_SIGN_OUT,
    responseType: 'code'
  },
  Auth: {
    region: AWS_REGION,
    userPoolId: COGNITO_USERPOOL_ID,
    userPoolWebClientId: COGNITO_CLIENT_ID,
    authenticationFlowType: 'USER_SRP_AUTH'
  }
};

console.log('info | configurazione | configurazione amplify: ' + JSON.stringify(amplifyConfiguration));

export { amplifyConfiguration };